/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Bydleni_CzInputs */

const cs_enum_bydleni_cz = /** @type {(inputs: Enum_Bydleni_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bydlení.cz`)
};

const en_enum_bydleni_cz = /** @type {(inputs: Enum_Bydleni_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bydleni.cz`)
};

/**
* | output |
* | --- |
* | "Bydleni.cz" |
*
* @param {Enum_Bydleni_CzInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_bydleni_cz = /** @type {((inputs?: Enum_Bydleni_CzInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Bydleni_CzInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_bydleni_cz(inputs)
	return cs_enum_bydleni_cz(inputs)
});